import * as React from 'react'
import {Box} from "@mui/material";
import {formatProductsUnits} from "@ui-seeker/utils";


export default function productsColumn() {
    return {
        name: 'numProducts', label: 'Nº Products',
        options: {
            customBodyRowRenderLite: value => <Box sx={{ textAlign: 'center' }}>
                {formatProductsUnits(value)}
            </Box>
        }
    }
}